const DEFAULT_CCS_BASE_URL = 'http://localhost:3001';
const SOURCE_APP_ID = process.env.REACT_APP_SOURCE_APP_ID
  || process.env.REACT_APP_FIREBASE_PROJECT_ID
  || 'ovplan1';

const trimTrailingSlash = (value = '') => String(value || '').replace(/\/+$/, '');

export const getCcsBaseUrl = () => (
  trimTrailingSlash(process.env.REACT_APP_CCS_BASE_URL) || DEFAULT_CCS_BASE_URL
);

const getCurrentAppLandingUrl = () => {
  if (typeof window === 'undefined') return '';
  return `${window.location.origin}/`;
};

export const buildCcsPricingUrl = ({
  tenantId = '',
  source = SOURCE_APP_ID,
  returnUrl = getCurrentAppLandingUrl(),
} = {}) => {
  const params = new URLSearchParams({
    appId: source || SOURCE_APP_ID,
    source,
  });

  if (tenantId) {
    params.set('tenantId', tenantId);
  }
  if (returnUrl) {
    params.set('returnUrl', returnUrl);
  }

  return `${getCcsBaseUrl()}/pricing?${params.toString()}`;
};
